import React from "react";
import { Link } from "react-router-dom";
import {
  FaHandshake,
  FaChalkboardTeacher,
  FaLightbulb,
  FaCogs,
  FaCheckCircle,
  FaLeaf,
  FaHardHat,
  FaUtensils,
} from "react-icons/fa";
import headerBg from "./assets/picOne.png";

const Training = () => {
  return (
    <div className="training-page">
      {/* === Section 1: Header Section (unchanged) === */}
      <section
        className="about-header"
        style={{
          backgroundImage: `url(${headerBg})`,
          backgroundSize: "cover",
          color: "white",
          backgroundPosition: "center",
          height: "45vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div className="overlay">
          <h1 className="page-title">Training</h1>
          <p
            className="subtitle"
            style={{
              color: "white",
            }}
          >
            MBS delivers expert research, training, and consultancy to improve
            quality, safety, and environmental performance.
          </p>
        </div>
      </section>

      {/* === Section 2: Overview === */}
      <section className="training-overview">
        <div className="content-wrapper">
          <h2>Industrial Research, Training & Consultancy</h2>
          <p className="overview-intro">
            Through the Industrial Research, Training, and Consultancy Unit
            (IRTACU), MBS offers client-based industrial research, training and
            consultancies in areas such as product improvement, safety, hygiene
            and environmental protection.
          </p>

          <div className="overview-list">
            <div className="overview-card">
              <FaHandshake className="list-icon" />
              <div>
                <h3>Industrial Research</h3>
                <p>
                  Custom research solutions that help businesses improve their
                  processes and optimize resources.
                </p>
              </div>
            </div>

            <div className="overview-card">
              <FaChalkboardTeacher className="list-icon" />
              <div>
                <h3>Professional Training</h3>
                <p>
                  Hands-on courses in management, safety, and compliance—led by
                  certified MBS staff members.
                </p>
              </div>
            </div>

            <div className="overview-card">
              <FaLightbulb className="list-icon" />
              <div>
                <h3>Consultancy Services</h3>
                <p>
                  Helping companies meet international standards through
                  tailored consultancy services.
                </p>
              </div>
            </div>

            <div className="overview-card">
              <FaCogs className="list-icon" />
              <div>
                <h3>Technical Support</h3>
                <p>
                  Assistance in implementing and maintaining management systems
                  for operational excellence.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* === Section 3: Training Areas === */}
      <section className="training-areas">
        <div className="content-wrapper">
          <h2>Our Core Training Areas</h2>
          <div className="training-grid">
            <div className="training-card">
              <FaCheckCircle className="training-icon" />
              <h3>Quality Management Systems (QMS)</h3>
              <p>
                Learn to implement ISO-based quality systems that drive
                excellence and continuous improvement.
              </p>
            </div>
            <div className="training-card">
              <FaUtensils className="training-icon" />
              <h3>Food Safety Management (FSMS)</h3>
              <p>
                Training focused on HACCP principles and food safety standards
                to ensure compliance and consumer confidence.
              </p>
            </div>
            <div className="training-card">
              <FaLeaf className="training-icon" />
              <h3>Environmental Management (EMS)</h3>
              <p>
                Understand ISO 14001 frameworks and sustainable practices for a
                cleaner, greener future.
              </p>
            </div>
            <div className="training-card">
              <FaHardHat className="training-icon" />
              <h3>Occupational Health & Safety (OHSMS)</h3>
              <p>
                Promote safe workplace culture and risk prevention through
                recognized OHS standards and training.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* === Section 4: Contact Section === */}
      <section className="training-contact">
        <div className="content-wrapper">
          <h2>Get in Touch</h2>
          <p>
            Whether you’re a company seeking specialized training or a team
            looking to improve compliance and performance, our consultants are
            ready to assist.
          </p>
          <p>
            Contact us at{" "}
            <a href="mailto:mbs@mbsmw.org" className="inline-link">
              mbs@mbsmw.org
            </a>{" "}
            to learn more about our programs or request a tailored training
            solution.
          </p>
        </div>
      </section>

      {/* === Inline CSS === */}
      <style>{`
        .overlay {
          background: rgba(0, 0, 0, 0.55);
          padding: 40px;
          text-align: center;
          color: white;
          width: 90%;
          max-width: 1200px;
          border-radius: 12px;
        }

        .page-title {
          font-size: 2.2rem;
          font-weight: bold;
          margin-bottom: 10px;
        }

        .subtitle {
          font-size: 1rem;
          margin-top: 5px;
          font-weight: 500;
        }

        /* === General Layout === */
        .training-page {
          overflow-x: hidden;
          font-family: 'Inter', Arial, sans-serif;
          color: #222;
        }

        .content-wrapper {
          max-width: 1200px;
          margin: 0 auto;
          padding: 60px 20px;
          line-height: 1.7;
        }

        h2 {
          font-size: 1.8rem;
          margin-bottom: 30px;
          font-weight: 700;
          color: #ff6600;
          text-align: center;
        }

        p {
          font-size: 1rem;
        }

        /* === Overview Section === */
        .training-overview {
          background: #f5f7fa;
          width: 100vw;
        }

        .overview-intro {
          text-align: center;
          max-width: 800px;
          margin: 0 auto 40px auto;
          font-size: 1.05rem;
        }

        .overview-list {
          display: flex;
          justify-content: space-between;
          align-items: stretch;
          gap: 20px;
          flex-wrap: nowrap;
          overflow-x: auto;
        }

        .overview-card {
          flex: 1;
          min-width: 250px;
          background: white;
          border-radius: 8px;
          padding: 20px;
          display: flex;
          align-items: flex-start;
          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
          transition: all 0.3s ease;
        }

        .overview-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 6px 15px rgba(0, 0, 0, 0.1);
          border-left: 3px solid #ff6600;
        }

        .list-icon {
          color: #ff6600;
          font-size: 1.2rem;
          margin-right: 12px;
          margin-top: 4px;
          flex-shrink: 0;
        }

        .overview-card h3 {
          margin: 0 0 5px;
          font-size: 1rem;
          font-weight: 600;
          color: #222;
        }

        .overview-card p {
          font-size: 0.9rem;
          color: #555;
          margin: 0;
        }

        /* === Training Areas === */
        .training-areas {
          background: #ffffff;
          width: 100vw;
        }

        .training-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 30px;
          margin-top: 40px;
        }

        .training-card {
          background: #f9f9f9;
          border: 1px solid #eee;
          border-radius: 10px;
          padding: 30px 20px;
          text-align: center;
          transition: all 0.3s ease;
          box-shadow: 0 3px 8px rgba(0,0,0,0.05);
        }

        .training-card:hover {
          transform: translateY(-6px);
          box-shadow: 0 6px 15px rgba(0,0,0,0.1);
          border-color: #ff6600;
        }

        .training-icon {
          font-size: 2rem;
          color: #ff6600;
          margin-bottom: 15px;
        }

        .training-card h3 {
          font-size: 1.1rem;
          color: #222;
          margin-bottom: 10px;
        }

        .training-card p {
          font-size: 0.9rem;
          color: #555;
        }

        /* === Contact Section === */
        .training-contact {
          background: #f5f7fa;
          color: #000;
          width: 100vw;
          text-align: center;
        }

        .training-contact h2 {
          color: #ff6600;
        }

        .training-contact p {
          color: #000;
          text-align: center;
          max-width: 800px;
          margin: 0 auto 16px auto;
        }

        /* === Links === */
        .inline-link {
          color: #ff6600;
          font-weight: 600;
          text-decoration: underline;
          transition: color 0.3s ease;
        }

        .inline-link:hover {
          color: #cc5200;
        }

        /* === Responsive === */
        @media (max-width: 992px) {
          .overview-list {
            flex-wrap: wrap;
          }

          .overview-card {
            flex: 1 1 45%;
          }
        }

        @media (max-width: 600px) {
          .overview-card {
            flex: 1 1 100%;
          }

          .list-icon {
            font-size: 1rem;
          }
        }
      `}</style>
    </div>
  );
};

export default Training;
